module.exports = "/static/assets/6cfa64a624fd2abf7415cde5ed097746.png";